import {Component, OnInit, Input, ViewChild, ElementRef, OnDestroy} from '@angular/core';
import {Router} from "@angular/router";
import {WindowRefService, NotifComparatorService, ApiService, TrackingService} from '@app/core';
import {Subscription} from 'rxjs/Subscription';
import {IViewresaPush} from '@app/shared';
import {TranslateService} from '@ngx-translate/core';

const routes = {
    saveResaPayPal: '/save-resa-paypal',
};
const GTMCheckoutProcess = {
    step_3: 3,
    step_4 : 4,
    payment_method: 'Paypal'
}
@Component({
    selector: 'app-paypal-form',
    templateUrl: './paypal-form.component.html',
    styleUrls: ['./paypal-form.component.scss']
})
export class PaypalFormComponent implements OnInit, OnDestroy {
    private readonly _ROUTE_VIEWRESA = '/checkprice/viewresa';
    @Input() ruid: string;
    @Input() infos: any;
    @Input() saveRoute: string;
    @ViewChild('paypal') paypalElement: ElementRef;
    config: any;
    notifSubscription: Subscription;
    isLoadingCardPay: boolean = false;

    constructor(private winRef: WindowRefService, private router: Router, private notifComparatorService: NotifComparatorService, private apiService: ApiService, private translate: TranslateService,private trackingService: TrackingService) {}

    ngOnInit() {
        this.loadPayPal();
        this.notifSubscription = this.notifComparatorService.watch().subscribe((data: IViewresaPush) => {
            console.log('push IViewresaPush ->', data);
            if (data.viewresa) {
                if (data.viewresa.ruid == this.ruid) {
                    console.log('redirection by push')
                    this._redirectToViewResa();
                }
            }
        });
    }


    ngOnDestroy() {
        this.notifSubscription.unsubscribe();
        console.log('ngOnDestroy');
    }

    private _createBtn() {
        paypal.Buttons({
            createOrder: (data, actions) => {
                // This function sets up the details of the transaction, including the amount and line item details.
                let p = new Promise((resolve, reject) => {
                    resolve({id: this.infos.orderId});
                });
                let res = p.then( (data :any)  => {
                    return data.id;
                });
                return res;
                /*
                return actions.order.create({
                    purchase_units: [{
                        amount: {
                            currency: this.infos.currency,
                            //currency_code: this.infos.currency,
                            value: this.infos.amount,
                        },
                        custom: this.ruid,
                        ruid: this.ruid,
                        idetab: this.winRef.appConfigSite.idEtab
                    }]
                });
                //*/
            },
            onApprove: (data, actions) => {
                // This function captures the funds from the transaction.
                //return actions.order.capture().then((details) => {
                    // This function shows a transaction success message to your buyer.
                    this.isLoadingCardPay = true;
                    this.trackingService.chekoutProcess(GTMCheckoutProcess.step_3,GTMCheckoutProcess.payment_method);
                    let params = {uid: this.ruid, orderID: data['orderID'], payerID: data['payerID'], facilitatorAccessToken: data['facilitatorAccessToken']};
                    this.apiService.post(this.saveRoute, params).subscribe(
                        rep => {
                            if (rep.status === 1) {
                                this._redirectToViewResa();
                                this.trackingService.chekoutProcess(GTMCheckoutProcess.step_4,null);
                            } else {
                                this.translate.get('static.oups...uneerreuresestproduite,mercipourvotrecomprehenssion').subscribe((res: string) => {
                                    alert(res); console.log(res);
                                })
                            }
                            this.isLoadingCardPay = false;
                        },
                        err => {
                            console.log('Error', err);
                            this.translate.get('static.oups...uneerreuresestproduite,mercipourvotrecomprehenssion').subscribe((res: string) => {
                                alert(res); console.log(res);
                            })
                            this.isLoadingCardPay = false;
                        }
                    );
                //});
            }
        }).render(this.paypalElement.nativeElement);
    }

    /**
     * load js stripe
     */
    private loadPayPal() {
        if (!this.winRef.nativeWindow.document.getElementById('paypal-script')) {
            let SB_CLIENT_ID = this.infos.paypalClientId, s = this.winRef.nativeWindow.document.createElement("script"), c = this.infos.currency;
            s.id = "paypal-script";
            s.type = "text/javascript";
            if(!!this.infos.paypalCurrenncy)  {
                c = this.infos.paypalCurrenncy;
            }
            s.src = "https://www.paypal.com/sdk/js?client-id=".concat(SB_CLIENT_ID,'&currency=',c);
            s.onload = () => {
                this._createBtn();
            }
            this.winRef.nativeWindow.document.body.appendChild(s);
            let meta = this.winRef.nativeWindow.document.createElement("meta");
            meta.httpEquiv = "X-UA-Compatible";
            meta.content = "IE=edge";
            this.winRef.nativeWindow.document.body.appendChild(meta);
        } else {
            this._createBtn();
        }
    }



    private _redirectToViewResa(): void {
        this.router.navigate([this._ROUTE_VIEWRESA, this.ruid]);
    }
}
